import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { get, post, put, del } from '../api/client.js';

const KEY = (target) => ['expenses', target || 'me'];

export function useExpenses({ target } = {}) {
  const qs = target ? `?user=${encodeURIComponent(target)}` : '';
  return useQuery({
    queryKey: KEY(target),
    queryFn: async () => (await get(`/api/expenses${qs}`)).expenses || [],
    staleTime: 15_000,
  });
}

export function useSubmitExpense() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body) => post('/api/expenses', body),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['expenses'] }),
  });
}

export function useUpdateExpense() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, ...body }) => put(`/api/expenses/${id}`, body),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['expenses'] }),
  });
}

export function useDeleteExpense() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id) => del(`/api/expenses/${id}`),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['expenses'] }),
  });
}

export function useApproveExpense() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id) => post(`/api/admin/expenses/${id}/approve`, {}),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['expenses'] }),
  });
}

export function useDenyExpense() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, reason }) => post(`/api/admin/expenses/${id}/deny`, { reason }),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['expenses'] }),
  });
}

// Foreman variants — route to /api/foreman/... which gates on the
// supervised-crew set. Bookkeepers + admins continue to use the admin
// hooks above; the page picks which to call based on role.
export function useForemanApproveExpense() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id) => post(`/api/foreman/expenses/${id}/approve`, {}),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['expenses'] }),
  });
}

export function useForemanDenyExpense() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, reason }) => post(`/api/foreman/expenses/${id}/deny`, { reason }),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['expenses'] }),
  });
}
